<form [formGroup]="form" class="container" [ngClass]="{ open: open }">
  @if (open) {
    <div class="button-wrapper" id="closeMenu" (click)="onToggle()">
      <bolt-icon name="xmark"></bolt-icon>
    </div>
  } @else {
    <div class="button-wrapper">
      <input
        id="openMenu"
        type="button"
        [value]="'\ud83d\udc1e'"
        (click)="onToggle()"
        />
      </div>
    }

    @if (open) {
      <div class="bolt-container-fluid">
        <p class="bolt-heading-xs bolt-space-bottom-md">Debug menu</p>
        @if (showEnvName()) {
          <div class="bolt-row bolt-align-items-center">
            <div class="bolt-col">
              <label for="debug-pc-env" class="faux-bolt-label">Env Config</label>
            </div>
            <div class="bolt-col">
              <bolt-select
                label=""
                id="env-name"
                formControlName="environmentName"
                arialabel="Environment Config"
                >
                @for (item of envNames | keyvalue; track item.key) {
                  <option [value]="item.key">
                    {{ item.value }}
                  </option>
                }
              </bolt-select>
            </div>
          </div>
        }
        <div class="bolt-row bolt-align-items-center">
          <div class="bolt-col">
            <label for="debug-pc-env" class="faux-bolt-label">PC Env</label>
          </div>
          <div class="bolt-col">
            <bolt-select
              label=""
              id="debug-pc-env"
              formControlName="pcEnv"
              arialabel="PC Environment"
              >
              @for (v of pcEnvironments; track v) {
                <option [value]="v">
                  {{ v }}
                </option>
              }
            </bolt-select>
            @if (alertPcEnvError) {
              <span id="pcAlertError" class="error">!</span>
            }
          </div>
          <div class="bolt-col-12">
            <div class="bolt-body-copy-sm">
              Don't change PC env after submitting PNI.
            </div>
          </div>
        </div>
        <div class="bolt-row bolt-align-items-center">
          <div class="bolt-col">
            <label for="debug-billing-env" class="faux-bolt-label">
              Billing Env
            </label>
          </div>
          <div class="bolt-col">
            <bolt-select
              id="debug-billing-env"
              formControlName="billingEnv"
              arialabel="Billing environment"
              >
              @for (v of billingEnvs; track v) {
                <option [value]="v">{{ v }}</option>
              }
            </bolt-select>
          </div>
        </div>
        <!-- <tr *ngIf="products$ | async">
        <td>
          <label for="debug-enabled-products">Enabled Products:</label>
        </td>
        <td formArrayName="products">
          <tr *ngFor="let product of formProducts?.controls">
            <input
              type="checkbox"
              id="debug-{{ product.value.type }}-product"
              [checked]="product.value.isAvailable"
              (change)="updateProducts(product.value, $event)"
              />&nbsp;<label for="debug-{{ product.value.type }}-product">{{
              product.value.type
            }}</label>
          </tr>
        </td>
      </tr> -->
      <div class="bolt-row bolt-align-items-center bolt-space-bottom-lg">
        <div class="bolt-col">
          <label for="auto-approve-uw" class="faux-bolt-label no-mb">
            Auto Approve UW Rules
          </label>
        </div>
        <div class="bolt-col-auto">
          <bolt-checkbox
            id="auto-approve-uw"
            formControlName="autoApproveUW"
            arialabel="Auto Approve UW Rules"
            >
          </bolt-checkbox>
        </div>
      </div>
      <div class="bolt-row bolt-align-items-center bolt-space-bottom-lg">
        <div class="bolt-col">
          <label for="autofill" class="faux-bolt-label no-mb">
            Enable autofill
          </label>
        </div>
        <div class="bolt-col-auto">
          <bolt-checkbox
            id="autofill"
            formControlName="autofill"
            arialabel="Enable autofill"
            >
          </bolt-checkbox>
        </div>
      </div>
      <div class="bolt-row bolt-align-items-center">
        <div class="bolt-col">
          <label for="navTarget" class="faux-bolt-label">Auto navigate</label>
        </div>
        <div class="bolt-col">
          <bolt-select
            id="navTarget"
            formControlName="autofillTarget"
            (change)="onAutofillChange($event)"
            arialabel="Auto navigate"
            >
            @for (page of pages$ | async; track page.name) {
              <option [value]="page.url">
                {{ page.name }}
              </option>
            }
          </bolt-select>
        </div>
      </div>
      @if (currentEnvironmentName === 'localdesktop') {
        <div
          class="bolt-row bolt-align-items-center bolt-space-bottom-lg"
          >
          <div class="bolt-col">
            <label for="persist-state-toggle" class="faux-bolt-label no-mb">
              Persist State
            </label>
          </div>
          <div class="bolt-col-auto">
            <bolt-checkbox
              id="persist-state-toggle"
              formControlName="persistStateToggle"
              arialabel="Persist State"
              (change)="onPersistStateToggleChange($event)"
              >
            </bolt-checkbox>
          </div>
        </div>
      }
      <div class="bolt-row bolt-align-items-center">
        <div class="bolt-col">
          <label for="manual-persona-name" class="faux-bolt-label"
            >Persona Name</label
            >
          </div>
          <div class="bolt-col">
            <bolt-select
              id="manual-persona-name"
              formControlName="manualPersonaName"
              arialabel="Manual Persona"
              >
              @for (persona of personaNames; track persona) {
                <option [value]="persona">
                  {{ persona }}
                </option>
              }
            </bolt-select>
          </div>
        </div>
      </div>
    }
  </form>
